// Support ticket status enum
export var SupportTicketStatus;
(function (SupportTicketStatus) {
    SupportTicketStatus["OPEN"] = "open";
    SupportTicketStatus["WAITING_FOR_USER"] = "waiting_for_user";
    SupportTicketStatus["WAITING_FOR_STAFF"] = "waiting_for_staff";
    SupportTicketStatus["RESOLVED"] = "resolved";
    SupportTicketStatus["CLOSED"] = "closed";
})(SupportTicketStatus || (SupportTicketStatus = {}));
// Support ticket type enum
export var SupportTicketType;
(function (SupportTicketType) {
    SupportTicketType["SUGGESTION"] = "suggestion";
    SupportTicketType["REQUEST"] = "request";
    SupportTicketType["COMPLAINT"] = "complaint";
})(SupportTicketType || (SupportTicketType = {}));
/**
 * The same values as literal-string tuples, for schema builders that need
 * literal types (`t.UnionEnum`, `z.enum`), for select controls, and for code
 * that handles the wire form (an enum member narrows to its literal, but a
 * literal never widens back to the enum). Pinned to the enum by `satisfies`.
 */
export const SUPPORT_TICKET_STATUSES = [
    "open",
    "waiting_for_user",
    "waiting_for_staff",
    "resolved",
    "closed",
];
export const SUPPORT_TICKET_TYPES = [
    "suggestion",
    "request",
    "complaint",
];
//# sourceMappingURL=SupportTicket.js.map